/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Loading_ReposInputs */



/**
* | output |
* | --- |
* | "Loading repositories…" |
*
* @param {Spaces_Loading_ReposInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_loading_repos = /** @type {((inputs?: Spaces_Loading_ReposInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Loading_ReposInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Repositories werden geladen…")
	return /** @type {LocalizedString} */ ("Loading repositories…")
});